import React, { useState, useEffect, useCallback } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { debounce } from "../utils/mediaUtils";

const SearchBar = ({ onSearch, searchText }) => {
  const [localValue, setLocalValue] = useState(searchText || "");

  const debouncedSearch = useCallback(
    debounce((value) => {
      onSearch(value);
    }, 300),
    [onSearch]
  );

  useEffect(() => {
    setLocalValue(searchText || "");
  }, [searchText]);

  const handleChange = (e) => {
    const value = e.target.value;
    setLocalValue(value);
    debouncedSearch(value);
  };

  return (
    <div className="creative-library__search">
      <Input
        placeholder="Search creatives..."
        value={localValue}
        onChange={handleChange}
        allowClear
        prefix={<SearchOutlined />}
      />
    </div>
  );
};

export default SearchBar;
